export default __webpack_public_path__ + "static/BannerGenericImageTextActionWithCharTitleAndAction-e4d8060e3a6153fcdfdbe0109d0a3d01.jpg";